interface TallyBarProps {
  name: string;
  count: number;
  maxCount: number;
  highlighted: boolean;
  votesLabel: string;
}

export function TallyBar({ name, count, maxCount, highlighted, votesLabel }: TallyBarProps) {
  const fraction = maxCount > 0 ? count / maxCount : 0;

  return (
    <div className="flex items-center gap-3">
      <span className={`w-24 shrink-0 truncate text-sm ${highlighted ? 'font-semibold text-fg' : 'text-fg-muted'}`}>
        {name}
      </span>
      <div className="h-3 flex-1 overflow-hidden rounded-full bg-surface-2">
        {/* Die Füllung wächst per CSS-Keyframe von `scaleX(0)`. Bewusst nicht
            per JS-Animation: fällt die aus, stünde der Balken dauerhaft leer da
            und das Ergebnis wäre schlicht nicht ablesbar. */}
        <div
          className={`h-full origin-left animate-bar-grow rounded-full transition-colors ${
            highlighted ? 'bg-accent' : 'bg-fg-faint'
          }`}
          style={{ width: `${fraction * 100}%` }}
        />
      </div>
      <span className="w-8 shrink-0 text-right text-sm tabular-nums text-fg-muted">{count}</span>
      <span className="sr-only">{votesLabel}</span>
    </div>
  );
}
